import { Button, Tooltip } from "@mui/material";
import React, { useContext, useState } from "react";

import DiaryEntryModal from "./DiaryEntryModal";
import RequestPermissionTooltip from "@/components/RequestPermissionTooltip";
import PermissionContext from "@/Contexts/Permissions";
import { PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";

const ReportDiary: React.FC = () => {
  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const [category, setCategory] = useState<'diary-entry' | null>(null);

  return (
    <>
      <RequestPermissionTooltip
        hasPermission={canPerformAction(PermissionActionEnum.Create, PermissionEntityEnum.Events)}
        requiredPermission={{
          action: PermissionActionEnum.Create,
          entity: PermissionEntityEnum.Events,
        }}
        checkRequestExists={checkRequestExists}
        onRequest={requestPermission}
      >
        <span>
          <Tooltip title="Diary entries for the day" placement="bottom">
            <Button
              variant="outlined"
              sx={{ maxWidth: 200 }}
              onClick={() => setCategory("diary-entry")}
              size='small'
              disabled={!canPerformAction(PermissionActionEnum.Create, PermissionEntityEnum.Events)}
            >
              Diary Entry
            </Button>
          </Tooltip>
        </span>
      </RequestPermissionTooltip>
      {category === 'diary-entry' && <DiaryEntryModal handleClose={() => setCategory(null)} />}
    </>
  );
};

export default ReportDiary;
